import { render, staticRenderFns } from "./Certificates.vue?vue&type=template&id=38c5c7cd&scoped=true"
import script from "./Certificates.vue?vue&type=script&lang=ts"
export * from "./Certificates.vue?vue&type=script&lang=ts"
import style0 from "./Certificates.vue?vue&type=style&index=0&id=38c5c7cd&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38c5c7cd",
  null
  
)

export default component.exports